import I18n from 'common/i18n';
import { OPERATOR } from 'common/components/FilterBar/SoqlFilter';

const agTextOperatorScope = 'shared.components.filter_bar.text_filter';

export const AG_GRID_TEXT_FILTER = {
  options: [
    {
      title: I18n.t(`${agTextOperatorScope}.is`),
      value: OPERATOR.EQUALS
    },
    {
      title: I18n.t(`${agTextOperatorScope}.is_not`),
      value: OPERATOR.NOT_EQUAL
    },
    {
      title: I18n.t(`${agTextOperatorScope}.starts_with`),
      value: OPERATOR.STARTS_WITH
    },
    {
      title: I18n.t(`${agTextOperatorScope}.contains`),
      value: OPERATOR.CONTAINS
    },
    {
      title: I18n.t(`${agTextOperatorScope}.does_not_contain`),
      value: OPERATOR.DOES_NOT_CONTAIN
    }
  ]
};

const agNumberOperatorScope = 'shared.components.filter_bar.range_filter.operators';

export const AG_GRID_NUMBER_FILTER = {
  options: [
    {
      title: I18n.t(`${agNumberOperatorScope}.equal.title`),
      value: '=',
      symbol: I18n.t(`${agNumberOperatorScope}.equal.symbol`)
    },
    {
      title: I18n.t(`${agNumberOperatorScope}.not_equal.title`),
      value: '!=',
      symbol: I18n.t(`${agNumberOperatorScope}.not_equal.symbol`)
    },
    {
      title: I18n.t(`${agNumberOperatorScope}.less_than.title`),
      value: '<',
      symbol: I18n.t(`${agNumberOperatorScope}.less_than.symbol`)
    },
    {
      title: I18n.t(`${agNumberOperatorScope}.greater_than.title`),
      value: '>',
      symbol: I18n.t(`${agNumberOperatorScope}.greater_than.symbol`)
    },
    {
      title: I18n.t(`${agNumberOperatorScope}.less_than_or_equal.title`),
      value: '<=',
      symbol: I18n.t(`${agNumberOperatorScope}.less_than_or_equal.symbol`)
    },
    {
      title: I18n.t(`${agNumberOperatorScope}.greater_than_or_equal.title`),
      value: '>=',
      symbol: I18n.t(`${agNumberOperatorScope}.greater_than_or_equal.symbol`)
    },
    {
      title: I18n.t(`${agNumberOperatorScope}.range_exclusive`),
      value: 'rangeExclusive'
    },
    {
      title: I18n.t(`${agNumberOperatorScope}.range_inclusive`),
      value: 'rangeInclusive'
    }
  ]
};

const agBooleanOptions = {
  TRUE: 'true',
  FALSE: 'false'
};

const agBooleanOperatorScope = 'shared.visualizations.panes.presentation.fields.ag_condition.boolean_options';

export const AG_GRID_BOOLEAN_FILTER = {
  options: [
    {
      title: I18n.t(`${agBooleanOperatorScope}.true`),
      value: agBooleanOptions.TRUE
    },
    {
      title: I18n.t(`${agBooleanOperatorScope}.false`),
      value: agBooleanOptions.FALSE
    }
  ]
};

export const agAlignType = {
  RIGHT: 'right',
  CENTER: 'center',
  LEFT: 'left'
};

export const AgFilterDataType = {
  NUMBER: 'number',
  TEXT: 'text',
  BOOLEAN: 'checkbox',
  DATE: 'date',
  CALENDAR: 'calendar_date'
};

export const AgGridColumnDataFormat = {
  NUMBER: 'number',
  TEXT: 'text',
  BOOLEAN: 'checkbox',
  DATE: 'date',
  CALENDAR: 'calendar_date'
};

const agTextFontStyleScope = 'shared.visualizations.panes.presentation.fields.ag_text_style.options';
const agConditionalTypeScope =
  'shared.visualizations.panes.presentation.fields.ag_column_conditional_type.options';

const agTextStyleOptions = {
  NORMAL: 'normal',
  SEMI_BOLD: 'semi_bold',
  BOLD: 'bold',
  ITALIC: 'italic'
};

export const agConditionalTypeOptions = {
  CONDITION: 'condition',
  LINEAR: 'linear'
};

export const AG_TEXT_FONT_STYLE = {
  OPTIONS: [
    {
      title: I18n.t('normal', { scope: agTextFontStyleScope }),
      value: agTextStyleOptions.NORMAL
    },
    {
      title: I18n.t('semi_bold', { scope: agTextFontStyleScope }),
      value: agTextStyleOptions.SEMI_BOLD
    },
    {
      title: I18n.t('bold', { scope: agTextFontStyleScope }),
      value: agTextStyleOptions.BOLD
    },
    {
      title: I18n.t('italic', { scope: agTextFontStyleScope }),
      value: agTextStyleOptions.ITALIC
    }
  ]
};

export const AG_CONDITIONAL_TYPE = {
  OPTIONS: [
    {
      title: I18n.t('condition', { scope: agConditionalTypeScope }),
      value: agConditionalTypeOptions.CONDITION
    },
    {
      title: I18n.t('linear', { scope: agConditionalTypeScope }),
      value: agConditionalTypeOptions.LINEAR
    }
  ]
};
